import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Register = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [msg, setMsg] = useState('');
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch('/api/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await res.json();
      if (res.ok) {
        navigate('/verify', { state: { email } });
      } else {
        setMsg(data.error);
      }
    } catch (err) { setMsg("Błąd serwera."); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0f172a] pt-20">
      <div className="bg-white/5 p-10 rounded-3xl border border-white/10 w-full max-w-md backdrop-blur-xl">
        <h2 className="text-3xl font-bold mb-8 text-center text-white">Stwórz konto</h2>
        {msg && <p className="mb-4 text-red-400 text-center bg-red-500/10 py-2 rounded-lg">{msg}</p>}
        <form onSubmit={handleRegister} className="space-y-4">
          <input type="email" placeholder="Email" className="w-full p-4 bg-black/20 border border-white/10 rounded-xl text-white focus:border-cyan-500 outline-none" onChange={e => setEmail(e.target.value)} required />
          <input type="password" placeholder="Hasło" className="w-full p-4 bg-black/20 border border-white/10 rounded-xl text-white focus:border-cyan-500 outline-none" onChange={e => setPassword(e.target.value)} required />
          <button className="w-full bg-gradient-to-r from-cyan-500 to-blue-600 py-4 rounded-xl font-bold text-white transition shadow-lg shadow-cyan-500/20">Zarejestruj się</button>
        </form>
        <p className="mt-6 text-center text-gray-400">Masz konto? <Link to="/login" className="text-cyan-400 hover:underline">Zaloguj się</Link></p>
      </div>
    </div>
  );
};
export default Register;